import { call, put, takeEvery } from "redux-saga/effects";

// Chat Redux States
import {
  getAppsParams,
  getCampaign,
  getCampaignDirectionType,
  getCampaignFormatsList,
  getCampaignMediaBuyerParams,
  getCampaignOfferTypeParams,
  getCampaignsList,
  getCampaignSources,
  getCampaignStatuses,
  getClientsList,
  putCampaign
} from "../../../helpers/jwt_helper";
import {
  GET_CAMPAIGN,
  GET_CAMPAIGN_APPLICATIONS_PROFILE_LIST,
  GET_CAMPAIGN_CLIENTS_PROFILE_LIST,
  GET_CAMPAIGN_DIRECTION_TYPE_PROFILE_LIST,
  GET_CAMPAIGN_FORMAT_PROFILE_LIST,
  GET_CAMPAIGN_MEDIA_BUYER_PROFILE_LIST,
  GET_CAMPAIGN_OFFER_TYPE_PROFILE_LIST,
  GET_CAMPAIGN_SOURCE_PROFILE_LIST,
  GET_CAMPAIGN_STATUS_PROFILE_LIST,
  UPDATE_CAMPAIGN_PROFILE
} from "./actionTypes";
import {
  setCampaign,
  setCampaignAppsList,
  setCampaignClientList,
  setCampaignDirectionTypeProfileList,
  setCampaignError,
  setCampaignFormatProfileList,
  setCampaignMediaBuyerProfileList,
  setCampaignOfferTypeProfileList,
  setCampaignSourceProfileList,
  setCampaignStatusProfileList
} from "./actions";
import { getErrorMessage, showErrorMessage, showSuccessMessage } from "../../../helpers/utils";
import { hideCampaignsListLoader, setCampaignsList, showCampaignsListLoader } from "../list/actions";

function* onGetCampaign({payload: id}) {
  try {
    yield put(setCampaignError(false));
    let response = yield call(getCampaign, id)
    yield put(setCampaign(response))
   } catch (error) {
    if (getErrorMessage(error) === 'Not found.') {
      yield put(setCampaignError(true));
    } else {
      showErrorMessage(getErrorMessage(error));
    }
  }
}

function* onGetAllClientList() {
  try {
    let size = 0;
    let response = yield call(getClientsList, {
      size: size
    })
    yield put(setCampaignClientList(response))
  } catch (error) {
      showErrorMessage(getErrorMessage(error));
  }
}

function* onGetAllApplicationList() {
  try {
    let size = 0;
    let response = yield call(getAppsParams, {
      size: size
    })
    yield put(setCampaignAppsList(response))
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetAllOfferTypeList() {
  try {
    let size = 0;
    let response = yield call(getCampaignOfferTypeParams, {
      size: size
    })
    yield put(setCampaignOfferTypeProfileList(response))
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetAllSourceList() {
  try {
    let size = 0;
    let response = yield call(getCampaignSources, {
      size: size
    })
    yield put(setCampaignSourceProfileList(response))
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetAllDirectionTypeList() {
  try {
    let size = 0;
    let response = yield call(getCampaignDirectionType, {
      size: size
    })
    yield put(setCampaignDirectionTypeProfileList(response))
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetAllStatusList() {
  try {
    let size = 0;
    let response = yield call(getCampaignStatuses, {
      size: size
    })
    yield put(setCampaignStatusProfileList(response))
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetAllMediaBuyerList() {
  try {
    let size = 0;
    let response = yield call(getCampaignMediaBuyerParams, {
      size: size
    })
    yield put(setCampaignMediaBuyerProfileList(response))
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetAllFormatList() {
  try {
    let size = 0;
    let response = yield call(getCampaignFormatsList, {
      size: size
    })
    yield put(setCampaignFormatProfileList(response))
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onUpdateCampaignProfile({ payload: {id, profile, data } }) {
  try {
    yield put(showCampaignsListLoader());
      yield call(putCampaign, id, {
      campaign_id: profile.campaignId,
      campaign_name: profile.campaignName,
      platform: profile.platform,
      account_name: profile.accountName,
      format: profile.campaignFormat,
      status: profile.campaignStatus,
      //client: profile.client,
      application: profile.clientApp,
      direction_type: profile.directionType,
      media_buyer: profile.mediaBuyer,
      offer_type: profile.offerType,
      source: profile.source,
    });
    let response = yield call(getCampaignsList, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      client: data.client,
      search: data.search
    });
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({...i, created_at: new Date(i.created_at).toDateString()}))
    }
    yield put(setCampaignsList(response));
    showSuccessMessage("Campaign has been updated");
    yield put(hideCampaignsListLoader());
  } catch (error) {
    yield put(hideCampaignsListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* campaignInfoSaga() {
  yield takeEvery(GET_CAMPAIGN, onGetCampaign);
  yield takeEvery(GET_CAMPAIGN_CLIENTS_PROFILE_LIST, onGetAllClientList);
  yield takeEvery(GET_CAMPAIGN_APPLICATIONS_PROFILE_LIST, onGetAllApplicationList);
  yield takeEvery(GET_CAMPAIGN_OFFER_TYPE_PROFILE_LIST, onGetAllOfferTypeList);
  yield takeEvery(GET_CAMPAIGN_SOURCE_PROFILE_LIST, onGetAllSourceList);
  yield takeEvery(GET_CAMPAIGN_DIRECTION_TYPE_PROFILE_LIST, onGetAllDirectionTypeList);
  yield takeEvery(GET_CAMPAIGN_STATUS_PROFILE_LIST, onGetAllStatusList);
  yield takeEvery(GET_CAMPAIGN_MEDIA_BUYER_PROFILE_LIST, onGetAllMediaBuyerList);
  yield takeEvery(GET_CAMPAIGN_FORMAT_PROFILE_LIST, onGetAllFormatList);
  yield takeEvery(UPDATE_CAMPAIGN_PROFILE, onUpdateCampaignProfile);
}

export default campaignInfoSaga;
